var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ts-link",class:{ primary: _vm.type === 'primary' }},[(_vm.disabled)?_c('span',{staticClass:"disabled"},[_vm._t("default")],2):_c('a',_vm._g(_vm._b({},'a',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }